export default __webpack_public_path__ + "94cf0a4876942a9259ac95eee5fdb174.svg";